export default __webpack_public_path__ + "static/media/checks.a673dc91.svg";